<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ix"></a>
<p class="noindent1"><em class="italic">They [our distant descendants in the twenty-first century] will come to the Pantheon of the revolution, they will rise, bowing their heads before the grey, majestic, wonderful walls of the Kremlin, and will look long upon the marble of funeral slabs, at the bronze death masks and bas-reliefs which, with time, will decorate the sepulchral bays.</em></p>
<p class="right"><em class="italic">Izvestia</em>, 20 July 1936, marking the tenth anniversary of the death of Felix Dzerzhinsky</p>
<p class="noindent1"><em class="italic">The problems of ‘telling truth to power’ haven’t changed fundamentally over the last few thousand years. Because of the pressure to tell authoritarian regimes only what they wish to hear, they always have been and always will be second-rate when it comes to the understanding of intelligence.</em></p>
<p class="right">Christopher Andrew</p>
<p class="center"><em class="italic">Despotic leaders do not rule alone.</em></p>
<p class="right">From publishers’ promo to Anne Applebaum, <em class="italic">Twilight of Democracy</em> (1921)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM03.vue?0d932871